/** Follow-up datetime pickers use 0 / 15 / 30 / 45 minute steps only. */
export const DATETIME_MINUTE_INTERVAL = 15;
export const DATETIME_LOCAL_STEP_SECONDS = DATETIME_MINUTE_INTERVAL * 60;

function pad2(n) {
  return String(n).padStart(2, '0');
}

export function snapDateToQuarterHour(date) {
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) {
    return null;
  }

  const totalMinutes = d.getHours() * 60 + d.getMinutes();
  let snappedMinutes = Math.round(totalMinutes / DATETIME_MINUTE_INTERVAL) * DATETIME_MINUTE_INTERVAL;

  if (snappedMinutes >= 24 * 60) {
    d.setDate(d.getDate() + 1);
    snappedMinutes = 0;
  }

  d.setHours(Math.floor(snappedMinutes / 60), snappedMinutes % 60, 0, 0);
  return d;
}

export function toDatetimeLocalValue(date) {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) {
    return '';
  }

  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function snapDatetimeLocalValue(value) {
  if (value == null || value === '') {
    return '';
  }

  const snapped = snapDateToQuarterHour(new Date(value));
  return snapped ? toDatetimeLocalValue(snapped) : String(value);
}
